import React from 'react';

const Timer = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4176_19067)'>
        <path
          d='M10.0467 0.673828H6.04666V2.00716H10.0467V0.673828ZM7.37999 9.34049H8.71333V5.34049H7.37999V9.34049ZM12.7333 4.92716L13.68 3.98049C13.3933 3.64049 13.08 3.32049 12.74 3.04049L11.7933 3.98716C10.76 3.16049 9.45999 2.66716 8.04666 2.66716C4.73333 2.66716 2.04666 5.35383 2.04666 8.66716C2.04666 11.9805 4.72666 14.6672 8.04666 14.6672C11.3667 14.6672 14.0467 11.9805 14.0467 8.66716C14.0467 7.26049 13.5533 5.96049 12.7333 4.92716ZM8.04666 13.3405C5.46666 13.3405 3.37999 11.2538 3.37999 8.67383C3.37999 6.09383 5.46666 4.00716 8.04666 4.00716C10.6267 4.00716 12.7133 6.09383 12.7133 8.67383C12.7133 11.2538 10.6267 13.3405 8.04666 13.3405Z'
          fill='#161410'
        />
      </g>
      <defs>
        <clipPath id='clip0_4176_19067'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Timer;
